function DatePicker2Validator(elemSelector) {
    var elem = (elemSelector instanceof HTMLInputElement)
        ? elemSelector
        : document.querySelector(elemSelector);

    if (elem == null) {
        return;
    }

    var requiredMsg = (elem.dataset && elem.dataset.valDate) ? elem.dataset.valDate : 'The field must be a date.';
    var isRequired = (elem.dataset && elem.dataset.valDate);
    var pastDateMsg = (elem.dataset && elem.dataset.pastDate) ? elem.dataset.pastDate : 'The field must be a past date.';
    var isPastDate = (elem.dataset && elem.dataset.pastDate);

    function showError(errorMsg) {
        var div = elem.parentElement.parentElement.parentElement;
        var label = div.querySelector('label.error');

        elem.classList.add('error');

        label
            && $(label).remove();

        $(div).append('<label class="error">' + errorMsg + '</label>');
    }

    function clearError() {
        var div = elem.parentElement.parentElement.parentElement;

        elem.classList.remove('error');

        $(div).find('label.error').remove();
    }

    function isRequiredValid() {
        return (elem.value !== '');
    }

    function isValidDateValid() {
        if (elem.value.length > 10) {
            return false;
        }

        return moment(elem.value, 'DD/MM/YYYY').isValid();
    }

    function isPastDateValid() {
        return moment().diff(moment(elem.value, 'DD/MM/YYYY')) > -1;
    }


    elem.addEventListener('change', function() {
        m.isValid()
            && clearError();
    });

    var m = {
        isValid: function() {
            var isValid = true;

            if (isRequired && !isRequiredValid()) {
                showError(requiredMsg);
                return false;
            }

            if (isRequired && !isValidDateValid()) {
                showError("Please enter a valid date DD/MM/YYY");
                return false;
            }

            if (isPastDate && (!isValidDateValid() || !isPastDateValid())) {
                showError(pastDateMsg);
                return false;
            }

            clearError();
            return isValid;
        }
    };

    return m;
};

